<template>
  <div>
    <div class="app-main-inner-row" style="padding-top: 10px;">
      <div class="filters">
        <el-form
          :inline="true"
          label-width="50px"
          label-position="left"
          @submit.native.prevent="filter.pageNum=1;toQuery()"
        >
          <el-form-item :label="$t('common.btn.query')">
            <el-input
              v-model="filter.likeName"
              no="queryInput"
              :placeholder="$t('common.tips.fuzzySearch')"
              style="width:310px"
            />
          </el-form-item>
        </el-form>
      </div>
      <div class="triggers">
        <el-button no="query" type="primary" @click="filter.pageNum=1;toQuery()">{{ $t('common.btn.query') }}</el-button>
        <el-button no="new" type="primary" @click="showEditDialog(true)">{{ $t('common.btn.new') }}</el-button>
        <el-button no="edit" type="primary" @click="showEditDialog(false)">{{ $t('common.btn.edit') }}</el-button>
        <el-button no="delete" type="danger" @click="remove">{{ $t('common.btn.delete') }}</el-button>
      </div>
    </div>
    <div class="app-main-inner-row row-grid">
      <cargo-ag-grid
        no="grid"
        config-module="101311"
        :grid-params.sync="girdParams"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
      />
    </div>
    <div class="app-main-inner-row row-pagination">
      <cargo-pagination
        v-show="total>0"
        no="pagination"
        :total="total"
        :page.sync="filter.pageNum"
        :limit.sync="filter.pageSize"
        @pagination="toQuery"
      />
    </div>
    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      width="690px"
      :close-on-click-modal="false"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="90px" label-position="left">
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item :label="$t('baseInfo.basicData.shippingTerm.serialNumber')">
                <el-input-number
                  v-model="editDialog.form.serialNumber"
                  no="serialNumber"
                  :min="1"
                  :precision="0"
                  controls-position="right"
                  style="width: 180px"
                  @blur="serialNumberBlur"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('baseInfo.basicData.shippingTerm.code')">
                <el-input v-model="editDialog.form.code" no="code" :disabled="tenantId!==PLATFORM_TENANT_ID" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item :label="$t('baseInfo.basicData.shippingTerm.name')">
                <el-input v-model="editDialog.form.name" no="name" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('baseInfo.basicData.shippingTerm.localName')">
                <el-input v-model="editDialog.form.localName" no="localName" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item
                :label="$t('baseInfo.basicData.shippingTerm.interchangeCode')"
                :disabled="tenantId!==PLATFORM_TENANT_ID"
              >
                <el-input v-model="editDialog.form.interchangeCode" no="interchangeCode" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$t('baseInfo.basicData.shippingTerm.isoCode')"
                :disabled="tenantId!==PLATFORM_TENANT_ID"
              >
                <el-input v-model="editDialog.form.isoCode" no="isoCode" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item :label="$t('baseInfo.basicData.shippingTerm.remark')">
            <el-input v-model="editDialog.form.remark" no="remark" type="textarea" :rows="3" />
          </el-form-item>
          <el-row v-show="tenantId !== PLATFORM_TENANT_ID" :gutter="10">
            <el-col :span="24" style="display: flex">
              <div style="width: 90px;color: #000000;float: left">{{ $t('CargoMsg.Cargo_FLCLType') }}</div>
              <el-cascader
                v-model="editDialog.containerLoadTypes"
                no="containerLoadTypes"
                :options="editDialog.optionsList"
                :props="{ multiple: true }"
                clearable
                placeholder=" "
                style="flex-grow: 1;"
              />
            </el-col>
          </el-row>
          <el-form-item v-show="tenantId !== PLATFORM_TENANT_ID" label="">
            <span style="color: red">{{ $t('baseInfo.basicData.shippingTerm.operationTypeTip') }}</span>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="editSave" type="primary" @click="save">{{ $t('common.btn.save') }}</el-button>
        <el-button no="editCancel" @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
    <!-- 新增弹窗（非平台维护） -->
    <el-dialog
      :visible.sync="platformDialog.visible"
      :title="$t('baseInfo.basicData.shippingTerm.addBaseShippingTerm')"
      width="950px"
      :close-on-click-modal="false"
    >
      <base-shipping-term />
      <span slot="footer">
        <el-button no="save" type="primary" @click="addFromPlatform">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel" @click="platformDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import baseShippingTerm from './baseShippingTerm'
import { getUserInfo } from '@/utils/auth'
import { getShippingTermList, getShippingTermsByPlatform, saveShippingTerm, addShippingTermByPlatform, saveShippingTerms, delShippingTerm } from '@/api/basicData/shippingTerm'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import ColumnUtils from '@/utils/ColumnUtils'
import { ShippingTermOperationType } from '@/class/model/mdm/ShippingTermOperationType'
import { validateOperationTypeInUsed } from '@/api/basicData/shippingTermOperationType'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import * as ContainerLoadType from '@/class/cargo/model/parameters/ContainerLoadType'
import * as ImportConstants from '@/class/cargo/model/parameters/ImportConstants'
export default {
  name: 'ShippingTerm',
  components: { baseShippingTerm },
  data() {
    return {
      PLATFORM_TENANT_ID: 1, // 平台维护的租户ID
      filter: {
        likeName: '',
        pageNum: 1,
        pageSize: 50
      },
      total: 0,
      girdParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          menuTabs: [], // 去掉每列的菜单
          filter: true
        }
      },
      columnDefs: [
        {
          headerName: '',
          checkboxSelection: true,
          width: 55,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: this.$t('baseInfo.basicData.shippingTerm.serialNumber'),
          field: 'serialNumber',
          width: 100
        },
        {
          headerName: this.$t('baseInfo.basicData.shippingTerm.code'),
          field: 'code',
          width: 100
        },
        {
          headerName: this.$t('baseInfo.basicData.shippingTerm.name'),
          field: 'name',
          width: 200
        },
        {
          headerName: this.$t('baseInfo.basicData.shippingTerm.localName'),
          field: 'localName',
          width: 200
        },
        {
          headerName: this.$t('baseInfo.basicData.shippingTerm.interchangeCode'),
          field: 'interchangeCode',
          width: 100
        },
        {
          headerName: this.$t('baseInfo.basicData.shippingTerm.isoCode'),
          field: 'isoCode',
          width: 100
        },
        {
          headerName: this.$t('baseInfo.basicData.shippingTerm.remark'),
          field: 'remark',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_FLCLType'),
          field: 'shippingTermOperationTypes',
          width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.shippingTermOperationTypeLabelFun(params.value)
          }
        }
      ],
      rowData: null,
      tenantId: '',
      editDialog: {
        visible: false,
        title: '',
        form: {
          uuid: '',
          serialNumber: '',
          code: '',
          name: '',
          localName: '',
          interchangeCode: '',
          isoCode: '',
          remark: '',
          shippingTermOperationTypes: []
        },
        containerLoadTypes: [],
        optionsList: []
      },
      platformDialog: {
        visible: false
      }
    }
  },
  computed: {
    gridApi() {
      return this.girdParams.api
    }
  },
  created() {
    const user = getUserInfo()
    this.tenantId = user.tenantId
  },
  methods: {
    onShow() {
      if (this.rowData === null) {
        this.rowData = []
        this.toQuery()
        this.editDialog.optionsList = []
        this.editDialog.optionsList.push({ ...this.setCargoTypeData('SE', this.$t('CargoMsg.Cargo_OceanExport'), Array.from(ContainerLoadType.CARGO_TYPES_BASIC_DATA)) })
        this.editDialog.optionsList.push({ ...this.setCargoTypeData('SI', this.$t('CargoMsg.Cargo_OceanImport'), Array.from(ImportConstants._cargoTypeInputList)) })
      }
    },
    /**
     * 组装下下拉框数据
     * @param lob 数控类型
     * @param label 类型名称
     * @param typeList 数据源
     * @returns {{}}
     */
    setCargoTypeData(lob, label, typeList) {
      const list = []
      for (const d of typeList) {
        const data = {}
        data.value = d.code
        data.label = this.$store.getters.language === 'zh' ? d.chineseName : d.englishName
        data.children = [{ value: true, label: this.$t('constant.BillType.MBL') }, { value: false, label: this.$t('constant.BillType.HBL') }]
        list.push({ ...data })
      }
      const oneLevelData = {}
      oneLevelData.value = lob
      oneLevelData.label = label
      oneLevelData.children = list
      return oneLevelData
    },
    toQuery(pageNum, callback) {
      const self = this
      let queryFunc = getShippingTermList
      if (self.tenantId === self.PLATFORM_TENANT_ID) {
        queryFunc = getShippingTermsByPlatform
      }
      const loading = getLoading()
      queryFunc(self.filter).then(res => {
        if (self.gridApi) {
          self.gridApi.setRowData(res.data.list)
        } else {
          self.rowData = res.data.list
        }
        self.filter.pageNum = res.data.pageNum
        self.filter.pageSize = res.data.pageSize
        self.total = Number(res.data.total)
      }).finally(() => loading.close())
    },
    showEditDialog(isNew) {
      if (isNew) {
        if (this.tenantId !== this.PLATFORM_TENANT_ID) {
          this.showPlatform()
          return
        }
        this.editDialog.form = {
          uuid: '',
          serialNumber: '',
          code: '',
          name: '',
          localName: '',
          interchangeCode: '',
          isoCode: '',
          remark: '',
          shippingTermOperationTypes: []
        }
        this.editDialog.containerLoadTypes = []
        this.editDialog.title = this.$t('CargoMsg.Cargo_NewTo') + this.$t('CargoMsg.Cargo_TransitTerm')
      } else {
        const rows = this.gridApi.getSelectedRows()
        if (rows.length === 0) {
          this.$message.warning(this.$t('common.tips.hasOneAtleast'))
          return
        }
        this.editDialog.form = { ...rows[0] }
        this.editDialog.containerLoadTypes = []
        const shippingTermOperationTypes = this.editDialog.form.shippingTermOperationTypes
        if (shippingTermOperationTypes && shippingTermOperationTypes.length > 0) {
          for (const item of shippingTermOperationTypes) {
            this.editDialog.containerLoadTypes.push([item.lob, item.containerLoadType, item.mbl])
          }
        }
        this.editDialog.title = this.$t('CargoMsg.Cargo_EditTo') + this.$t('CargoMsg.Cargo_TransitTerm')
      }
      this.editDialog.visible = true
    },
    serialNumberBlur() {
      const form = this.editDialog.form
      const val = Number(form.serialNumber)
      if (isNaN(val)) {
        form.serialNumber = ''
        return
      }
      form.serialNumber = val.toFixed(0)
    },
    async save() {
      const self = this
      const form = self.editDialog.form
      if (!form.serialNumber && Number(form.serialNumber) !== 0) {
        self.$message.warning(self.$t('baseInfo.basicData.shippingTerm.serialNumberCheck'))
        return
      }
      if (!form.code) {
        self.$message.warning(self.$t('baseInfo.basicData.shippingTerm.codeCheck'))
        return
      }
      if (!form.name) {
        self.$message.warning(self.$t('baseInfo.basicData.shippingTerm.nameCheck'))
        return
      }
      if (!form.interchangeCode) {
        self.$message.warning(self.$t('baseInfo.basicData.shippingTerm.interchangeCodeCheck'))
        return
      }
      if (!form.isoCode) {
        self.$message.warning(self.$t('baseInfo.basicData.shippingTerm.isoCodeCheck'))
        return
      }
      if (self.tenantId !== self.PLATFORM_TENANT_ID) {
        if (this.editDialog.containerLoadTypes && this.editDialog.containerLoadTypes.length > 0) {
          const containerLoadTypes = []
          for (const item of this.editDialog.containerLoadTypes) {
            containerLoadTypes.push(item[0] + '-' + item[1] + '-' + (item[2] ? '1' : '0'))
          }
          const validateResult = await validateOperationTypeInUsed({ checkContainerLoadTypes: containerLoadTypes, uuid: this.editDialog.form.uuid }).then(res => res.data)
          if (validateResult) {
            const item = validateResult.split('-')
            const isZh = this.$store.getters.language === 'zh'
            const texts = ['', '', '']
            let list = ContainerLoadType.CONTAINERLOAD_TYPES
            texts[0] = this.$t('CargoMsg.Cargo_OceanExport')
            if (item[0] === 'SI') {
              list = ImportConstants._cargoTypeInputList
              texts[0] = this.$t('CargoMsg.Cargo_OceanImport')
            }
            const state = CommonState.getStateByCode(list, item[1])
            if (state) {
              if (isZh) {
                texts[1] = state.chineseName
              } else {
                texts[1] = state.englishName
              }
              texts[2] = ColumnUtils.getMblOrHblName(String(item[2]) === '1')
            }
            this.$message.warning(this.$t('Message.OperationTypeInUsed', texts))
            return
          }
        }
        this.handleShippingTermOperationTypes(form, this.editDialog.containerLoadTypes || [])
      }
      let saveFunc = saveShippingTerm
      if (!form.uuid && self.tenantId === self.PLATFORM_TENANT_ID) {
        saveFunc = addShippingTermByPlatform
      }
      const loading = getLoading4Cxt(this)
      saveFunc(form).then(res => {
        loading.close()
        if (!form.uuid) {
          self.filter.pageNum = 1
        }
        self.toQuery()
        self.editDialog.visible = false
        self.$message.success(self.$t('common.tips.saveSuccess'))
      }).catch(() => {
        loading.close()
        self.editDialog.visible = false
      })
    },
    remove() {
      const self = this
      const rows = self.gridApi.getSelectedRows()
      if (rows.length === 0) {
        self.$message.warning(self.$t('common.tips.hasOneAtleast'))
        return
      }
      self.$confirm(self.$t('common.tips.confirmDelete'), self.$t('common.tips.prompt'), {
        confirmButtonText: self.$t('common.btn.ok'),
        cancelButtonText: self.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        delShippingTerm(rows[0].uuid).then(res => {
          self.filter.pageNum = 1
          self.toQuery()
          self.$message.success(self.$t('common.tips.deleteSuccess'))
        })
      }).catch(() => { })
    },
    showPlatform() {
      if (document.resetBaseShippingTerm) {
        document.resetBaseShippingTerm()
      } else {
        setTimeout(() => {
          document.resetBaseShippingTerm()
        })
      }
      this.platformDialog.visible = true
    },
    addFromPlatform() {
      const self = this
      const rows = document.getSelectedBaseShippingTermRows()
      if (rows.length === 0) {
        self.$message.warning(self.$t('common.tips.hasOneAtleast'))
        return
      }
      const form = []
      for (let i = 0; i < rows.length; ++i) {
        const item = rows[i]
        form.push({
          serialNumber: item.serialNumber,
          code: item.code,
          name: item.name,
          localName: item.localName,
          interchangeCode: item.interchangeCode,
          isoCode: item.isoCode,
          remark: item.remark
        })
      }
      saveShippingTerms(form).then(res => {
        self.filter.pageNum = 1
        self.toQuery()
        self.platformDialog.visible = false
        self.$message.success(self.$t('common.tips.saveSuccess'))
      }).catch(() => {
        self.platformDialog.visible = false
      })
    },
    handleShippingTermOperationTypes(form, containerLoadTypes) {
      const newOperationTypes = []
      // 判断被删除的
      for (const item of form.shippingTermOperationTypes) {
        let isFind = false
        for (const containerLoadType of containerLoadTypes) {
          if (containerLoadType && containerLoadType[0] === item.lob && containerLoadType[1] === item.containerLoadType && containerLoadType[2] === item.mbl) {
            isFind = true
            break
          }
        }
        if (!isFind) {
          newOperationTypes.push({ ...item, deleted: true })
        }
      }
      // 判断新增的
      for (const containerLoadType of containerLoadTypes) {
        let isFind = false
        for (const item of form.shippingTermOperationTypes) {
          if (containerLoadType && containerLoadType[0] === item.lob && containerLoadType[1] === item.containerLoadType && containerLoadType[2] === item.mbl) {
            isFind = true
            break
          }
        }
        if (!isFind) {
          const shippingTermOperationType = new ShippingTermOperationType().fillDefaultValue().getData()
          shippingTermOperationType.shippingTermUuid = this.editDialog.form.uuid
          shippingTermOperationType.lob = containerLoadType[0]
          shippingTermOperationType.containerLoadType = containerLoadType[1]
          shippingTermOperationType.mbl = containerLoadType[2]
          newOperationTypes.push(shippingTermOperationType)
        }
      }
      form.shippingTermOperationTypes = newOperationTypes
    }
  }
}
</script>

<style>
</style>
